import WGW from './WGW';

export default WGW;
